import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import type { Legend as Props } from './legend.types';

declare module 'react' {
  /**
   * CSSProperties is missing support for custom variables,
   * so we add it for `--color` here.
   *
   * Consider something like this if we need a global solution.
   *
   * ```
   * [key: `--${string}`]: string | number
   * ```
   */
  interface CSSProperties {
    '--color'?: string;
  }
}

export const Legend: React.FC<Props> = ({ entries }) => (
  <div className="legend">
    {entries.map(entry => (
      <div className="legend__item" key={entry.id}>
        <div className="legend__indicator" style={{ '--color': entry.color }} />
        <Text size={Text.sizes.small}>{entry.text}</Text>
      </div>
    ))}
  </div>
);
